import { useState } from 'react';
import { useSnackbar } from 'notistack';

import HttpClient from '../../shared/infrastructures/clients/http.client';
import { extractTranslatedApiErrorMessage } from '../../shared/utils/translate-api-error.util';
import { Tax } from '../types/tax.type';
import { CreateTaxRequestDTO } from '../types/dtos/create-tax.dto';
import { ADMIN_TAXES_API_PATHS } from '../constants/taxes-api-paths.constants';

type UseCreateTaxResult = {
  createTax: (taxData: CreateTaxRequestDTO) => Promise<Tax | null>;
  isSubmitting: boolean;
};

export function useCreateTax(): UseCreateTaxResult {
  const { enqueueSnackbar } = useSnackbar();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const createTax = async (taxData: CreateTaxRequestDTO): Promise<Tax | null> => {
    setIsSubmitting(true);

    try {
      const createdTax = await HttpClient.post<Tax, CreateTaxRequestDTO>(ADMIN_TAXES_API_PATHS.CREATE_TAX, taxData);

      enqueueSnackbar('La taxe a été créée', { variant: 'success' });
      return createdTax;
    } catch (error) {
      enqueueSnackbar(
        extractTranslatedApiErrorMessage(error, 'Une erreur est survenue lors de la création de la taxe'),
        {
          variant: 'error',
        }
      );
      return null;
    } finally {
      setIsSubmitting(false);
    }
  };

  return { createTax, isSubmitting };
}
